import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import { CtaWhatsApp } from "../components/Cta";
import { Reveal } from "../components/motion";

const MANIFESTO = [
  { n: "01", t: "Le design d'abord", d: "Une carte digitale est un objet que l'on tend, que l'on pose, que l'on montre. Nous le dessinons comme une pièce de marque : vos couleurs, votre logo, votre univers." },
  { n: "02", t: "La personnalisation, pour de vrai", d: "Pas de gabarit générique : chaque carte et chaque page digitale partent de votre identité visuelle et de vos priorités — avis, abonnés ou contact." },
  { n: "03", t: "La simplicité comme standard", d: "Aucune application, aucun compte, aucun jargon. Un geste du smartphone suffit. Si une technologie complique l'expérience, elle n'a pas sa place chez nous." },
  { n: "04", t: "La technologie, invisible", d: "Le NFC est un moyen, jamais le message. La seule chose que vos clients doivent remarquer, c'est la fluidité de l'expérience." },
  { n: "05", t: "L'expérience client, humaine", d: "Tout passe par une conversation WhatsApp avec de vraies personnes, qui répondent en moins de 30 minutes et valident chaque détail avec vous avant production." },
  { n: "06", t: "Votre image, partout", d: "Un restaurant gastronomique comme une équipe commerciale méritent une identité digitale à leur hauteur. C'est exactement ce que nous construisons." },
];

export default function APropos() {
  return (
    <>
      <Seo
        title="À propos"
        description="Noveocard est une marque premium d'identité digitale : design, personnalisation, simplicité et technologie au service de l'image des professionnels."
        path="/a-propos"
      />

      <PageHero
        dark
        eyebrow="À propos"
        titleLines={["L'identité digitale,", "dessinée avec soin."]}
        description="Noveocard est née d'une conviction : l'identité d'un professionnel ne tient plus sur un bout de papier. Elle vit dans son univers digital — et il suffit d'un geste pour y ouvrir la porte."
      />

      <section className="bg-white py-20 sm:py-28">
        <div className="container-nv">
          <Reveal className="max-w-3xl">
            <p className="eyebrow">Notre manifeste</p>
            <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-nuit-900 sm:text-5xl">
              Nous ne vendons pas des cartes NFC. Nous dessinons des identités digitales.
            </h2>
          </Reveal>
          <div className="mt-16">
            {MANIFESTO.map((m, i) => (
              <Reveal key={m.n} delay={0.03}>
                <div className="grid gap-4 border-t border-nuit-900/10 py-10 sm:grid-cols-[auto_auto_1fr] sm:gap-12">
                  <span className="font-display text-5xl font-bold leading-none text-brume-300 sm:text-7xl" aria-hidden="true">
                    {m.n}
                  </span>
                  <h3 className="max-w-xs font-display text-xl font-bold text-nuit-900 sm:text-2xl">{m.t}</h3>
                  <p className="max-w-2xl text-base leading-relaxed text-steel sm:text-lg">{m.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="grain relative overflow-hidden bg-nuit-900 py-20 text-center text-white sm:py-24">
        <div className="container-nv relative">
          <Reveal>
            <p className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
              Discutons de votre identité digitale.
            </p>
            <p className="mx-auto mt-4 max-w-lg text-white/70">
              Racontez-nous votre activité : nous vous répondons en moins de 30 minutes.
            </p>
            <CtaWhatsApp
              label="Nous contacter sur WhatsApp"
              message="Bonjour Noveocard, je viens de lire votre manifeste et j'aimerais échanger sur mon projet."
              className="mt-8"
              size="lg"
              testid="apropos-cta-whatsapp"
            />
          </Reveal>
        </div>
      </section>
    </>
  );
}
